import {RouteComponentProps} from "react-router-dom";
import Loading from "components/loading";
import * as React from "react";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {useEffect, useState} from "react";
import {getOpportunity, getProcessModes} from "consent/api";
import {storeProcessModes} from "consent/actions";
import {getRepayRoute} from "consent/repayment/route";
import {IProcessModes} from "StateInterface";
import {Button} from "web-com";
import ContainerBox from "myshubhlife-component/container-box";
import {LenderName} from "utils/lenderDetails";
import Flashcard from "myshubhlife-component/Flashcard";
import {partnerOfferings} from "login/config";

interface IConnectProps {
  productCode: string;
  processModes: IProcessModes;
  lenderId: number;
  oppId: string;
  dispatch?: (action: any) => void;
  utm_source?: string;
}

enum MessageType {
  ERROR = "ERROR",
}
enum ErrorMessages {
  bankNotFound = "Looks like your bank account details are missing",
  eNachSupport = "Your bank is not supporting e-NACH",
  other = "Please try again later",
}
const bankNotFound = "bankAccounts not found";

function RepaymentIndex(props: IConnectProps & RouteComponentProps) {
  const [processMode, setProcessMode] = useState<IProcessModes>(props.processModes || null);
  const [loading, setLoading] = useState(false);
  const [error , setError] = useState<string>(null);
  const [lenderLoanAcctId, setLenderLoanAcctId] = useState<number>(null);
  const [isReload, setIsReload] = useState(false);
  const getOppDetails = async () => {
    try {
      const response = await getOpportunity(props.oppId);
      if (response.lenderLoanAcctId) {
        setLenderLoanAcctId(response.lenderLoanAcctId);
      }
    } catch (err) {
      setError(ErrorMessages.other);
      setIsReload(true);
    }
  };
  useEffect(() => {
    let interval;
    if (props.lenderId === LenderName.DMI && !lenderLoanAcctId && !isReload) {
      interval = setInterval(() => {
        getOppDetails();
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [lenderLoanAcctId, props.lenderId, isReload]);

  useEffect(() => {
    if (!props.processModes && props.productCode) {
      setLoading(true);
      getProcessModes(props.productCode, props.lenderId, props.oppId)
      .then((response) => {
        setLoading(false);
        if (response.data && response.data.Repayment && response.data.Repayment.length) {
          setProcessMode(response.data);
          props.dispatch(storeProcessModes(response.data));
        } else {
          setError(ErrorMessages.eNachSupport);
        }
      }).catch((err) => {
        setLoading(false);
        setError(err.response && err.response.data ?
            err.response.data.includes(bankNotFound) ?
            ErrorMessages.bankNotFound : err.response.data : ErrorMessages.other);
      });
    }
  }, [props.productCode]);
  const handleTryAgain = () => {
    getOppDetails();
    setError(null);
    setIsReload(false);
  };
  return (
    <div>
      <Loading
          active={loading || (props.lenderId === LenderName.DMI && !lenderLoanAcctId && !isReload)}
          msg={"Please wait, it might take some time"}
      />
      <div>
        {
          !loading && !error && processMode &&
          processMode.Repayment &&
          processMode.Repayment.length && getRepayRoute(props.match.path)
        }
        {
          error && !loading &&
          <ContainerBox>
            <Flashcard
              description={error}
              messageType={MessageType.ERROR}
              heading="Error!"
              supportText="Please reach out to us at"
              supportEmail={true}
              supportEmailText={partnerOfferings[props.utm_source]?.supportEmail}/>
            {
              isReload && <Button
                  buttonText="Try Again"
                  onClick={handleTryAgain}
              />
            }
          </ContainerBox>
        }
      </div>
    </div>
  );
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
  const loanApprovalInfo = state.consent.loanApprovalInfo;
  return {
    productCode: state.consent.loanApprovalInfo ? state.consent.loanApprovalInfo.productCode : null,
    processModes : state.consent.consentProcessMode ? state.consent.consentProcessMode.processModes : null,
    lenderId: state.consent.loanApprovalInfo ? state.consent.loanApprovalInfo.lenderId : null,
    oppId: state.consent.lenderOpportunityId ? state.consent.lenderOpportunityId : null,
    utm_source: state.login.authExt && state.login.authExt.utm_source ? state.login.authExt.utm_source : null,
  };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(RepaymentIndex);
